import { createContext, Dispatch, SetStateAction } from 'react';
import { Upload as TusUpload } from 'tus-js-client';

import { DbCommit, DbFolder } from '~src/types/db';

export interface FileProgress {
  id: string;
  folder?: FolderEntry;
  commit: DbCommit;
  projectId: number;
  file: File;
  description?: string;
  versionStr?: string;
  entityCreated: boolean;
  tusUpload?: TusUpload;
  tenderId?: string;
  error?: any;
  progress: {
    bytesTotal: number;
    bytesUploaded: number;
    percentage: string;
  };
  isDone: boolean;
  shouldStartUpload: boolean;
  contractId?: string;
  voucherId?: string;
  tags?: any;
  // === NEW: vendor offer/voucher response attachments ===
  shareId?: string;
  shareKey?: string;
  offerId?: number;
  isVendorVoucherResponse?: boolean;
  isEvaluationInstantMessageAttachment?: boolean;
}

export interface AttachmentProgress {
  id: string;
  folder?: FolderEntry;
  projectId: number;
  file: File;
  commit: DbCommit;
  description?: string;
  versionStr?: string;
  entityCreated: boolean;
  tusUpload?: TusUpload;
  tenderId?: string;
  error?: any;
  progress: {
    bytesTotal: number;
    bytesUploaded: number;
    percentage: string;
  };
  isDone: boolean;
  shouldStartUpload: boolean;
  contractId?: string;
  voucherId?: string;
  tags: any;
  // === NEW: vendor offer/voucher response attachments ===
  shareId?: string;
  shareKey?: string;
  offerId?: number;
  isVendorVoucherResponse?: boolean;
  isEvaluationInstantMessageAttachment?: boolean;
}

/** Parent for a file upload */
export type FolderEntry = {
  dbFolder: DbFolder;
  isNew: boolean;
};

export interface FileProgressCtx {
  fileProgressContext: FileProgress[] | AttachmentProgress[];
  setFileProgressContext: Dispatch<
    SetStateAction<FileProgressCtx['fileProgressContext']>
  >;
}

/**
 * Holds file data + tus object
 */
const FileProgressContext = createContext({
  fileProgressContext: [],
  setFileProgressContext: () => [],
} as FileProgressCtx);

export default FileProgressContext;
